import { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  InputGroup,
  Form,
  Alert,
  Button,
} from 'react-bootstrap';
import { AdvanceSalaryRespone } from '../../../model/datatype';
import { setRequestSalary } from '../../../services/ApiPostRequestSalary';
import { getRequestDetail } from '../../../services/ApiGetRequestDetail';
import { delRequestSalary } from '../../../services/ApiDelRequestSalary';
import Moment from 'moment';
import moment from 'moment-timezone';
import { NotifyModal } from '../../../modal/NotifyModal';
import { useTranslation } from 'react-i18next';

export const SalaryRequestDetail = (props: any) => {
  const [templateError, setTemplateError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [btnConfirm, setbtnConfirm] = useState('no');
  const [modalBackdrop, setModalBackdrop] = useState('true');
  const [modalKeyboard, setModalKeyboard] = useState(true);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setmodalBody] = useState('');
  const [modalConfirm, setModalConfirm] = useState(false);
  const [value, setValue] = useState<string | number>(0);
  const [valueInt, setvalueInt] = useState(0);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [data, setData] = useState<AdvanceSalaryRespone | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';

  useEffect(() => {
    let isMounted = true;
    
    const fetchData = async () => {
      setIsLoading(true);
      
      // Check for cached data first
      const cachedData = sessionStorage.getItem('salary_request_detail_cache');
      const cacheTimestamp = sessionStorage.getItem('salary_request_detail_timestamp');
      
      // Use cache if it's less than 1 minutes old
      const isCacheValid = cacheTimestamp && 
                          Date.now() - parseInt(cacheTimestamp) < 1 * 60 * 1000;
                          
      if (cachedData && isCacheValid) {
        if (isMounted) {
          setData(JSON.parse(cachedData));
          setIsLoading(false);
          return;
        }
      }
      
      // Otherwise fetch fresh data
      try {
        const response = await getRequestDetail();
        if (isMounted) {
          // Store in cache
          sessionStorage.setItem('salary_request_detail_cache', JSON.stringify(response));
          sessionStorage.setItem('salary_request_detail_timestamp', Date.now().toString());
          
          setData(response);
          setError('');
        }
      } catch (err) {
        if (isMounted) {
          setError('Failed to load data. Please try again.');
          console.error('Error fetching data:', err);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (data === null) {
      fetchData();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  let { t } = useTranslation();

  if (localStorage.getItem('Language') === 'en') {
    Moment.locale('en-sg');
  } else {
    Moment.locale('th');
  }

  // Add function to manually refresh the data
  const refreshData = () => {
    // Clear cache
    sessionStorage.removeItem('salary_request_detail_cache');
    sessionStorage.removeItem('salary_request_detail_timestamp');
    setData(null);
    setError('');
  };

  if (error) {
    return (
      <div className="text-center my-5">
        <Alert variant="danger">{error}</Alert>
        <Button 
          variant="outline-primary" 
          className="mt-3" 
          onClick={refreshData}
        >
          {t('btn_try_again') || 'Try Again'}
        </Button>
      </div>
    );
  }
  
  // ถ้าไม่มีข้อมูล และไม่ได้อยู่ระหว่างการโหลด ให้แสดงข้อความและปุ่มรีเฟรช
  if (data === null && !isLoading) {
    return (
      <div className="text-center my-5">
        <div>{t('text_notfound')}</div>
        <Button 
          variant="outline-primary" 
          className="mt-3" 
          onClick={refreshData}
        >
          {t('btn_refresh') || 'Refresh'}
        </Button>
      </div>
    );
  }

  const renderStatus = () => {
    switch (data?.advanceSalaryRequest?.status) {
      case 0:
        return (
          <Button variant="primary" className="btn-pending">
            Pending
          </Button>
        );
      case 1:
        return (
          <Button variant="primary" className="btn-approved">
            Approved
          </Button>
        );
      case 9:
        return (
          <Button variant="primary" className="btn-reject">
            Rejected
          </Button>
        );
      default:
        return '';
    }
  };

  function separator(numb: any) {
    if (!numb) return '';
    const str = numb.toString().split('.');
    str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return str.join('.');
  }

  function handleChange(e: any) {
    const result = e.target.value.replace(/\D/g, '');
    const amount = separator(result);
    setvalueInt(parseInt(result, 10) || 0);
    setValue(amount);
    setTemplateError('');
  }

  function hanleCancel(id: any, status: any) {
    if (status === 'del') {
      setModalTitle(t('notification'));
      setmodalBody(t('confirmCancel'));
      setbtnConfirm('yes');
      setModalConfirm(true);
      setShowModal(true);
      setTemplateError('');
    }

    if (status === 'confirm') {
      setModalConfirm(false);
      setIsLoading(true);
      
      delRequestSalary(id).then((response) => {
        // ล้าง cache
        sessionStorage.removeItem('salary_request_detail_cache');
        sessionStorage.removeItem('salary_request_detail_timestamp');
        localStorage.removeItem('obj_request_detail');
        
        // รีเซ็ตสถานะ
        setbtnConfirm('no');
        setShowModal(false);
        setTemplateError('');
        
        // ดึงข้อมูลใหม่หลังยกเลิกสำเร็จ
        setTimeout(() => {
          getRequestDetail()
            .then(newData => {
              setData(newData);
              sessionStorage.setItem('salary_request_detail_cache', JSON.stringify(newData));
              sessionStorage.setItem('salary_request_detail_timestamp', Date.now().toString());
              setIsLoading(false);
            })
            .catch(err => {
              console.error('Error fetching updated data after cancellation:', err);
              setError('Failed to refresh data after cancellation.');
              setData(null);
              setIsLoading(false);
            });
        }, 1000); // รอ 1 วินาทีเพื่อให้ข้อมูลในฐานข้อมูล update ก่อน
      }).catch(error => {
        console.error('Error canceling request:', error);
        setTemplateError('Failed to cancel request. Please try again.');
        setIsLoading(false);
      });
    }
  }

  function handleSubmit(e: any) {
    e.preventDefault();
    
    // Validation with helpful error message
    if (!inRange(valueInt, 500, 999999)) {
      const errorMessage = valueInt < 500 
        ? t('adv_salary_request.massage') || 'Amount must be at least 500' 
        : t('adv_salary_request.massage') || 'Amount must not exceed limit';
        
      setModalTitle(t('notification'));
      setmodalBody(errorMessage || t('notificationFail'));
      setModalConfirm(false);
      setbtnConfirm('no');
      setShowModal(true);
      return;
    }
    
    setButtonDisable(true);
    setTemplateError('');
    
    setRequestSalary(valueInt)
      .then((response) => {
        const result: any = response;
        if (result?.status === 200) {
          // Success - show notification
          setModalTitle(t('notification'));
          setmodalBody(t('notificationSuccess'));
          setShowModal(true);
          
          // Clear all caches for this feature to ensure fresh data on next load
          sessionStorage.removeItem('salary_request_detail_cache');
          sessionStorage.removeItem('salary_request_detail_timestamp');
          sessionStorage.removeItem('obj_request_detail');
          localStorage.removeItem('obj_request_detail');
          
          // Reset form values
          setValue(0);
          setvalueInt(0);
          
          // Set loading state and fetch fresh data
          setIsLoading(true);
          
          // เรียก API เพื่อดึงข้อมูลใหม่หลังจากส่งคำขอสำเร็จ
          setTimeout(() => {
            getRequestDetail()
              .then(newData => {
                setData(newData);
                // Store in cache
                sessionStorage.setItem('salary_request_detail_cache', JSON.stringify(newData));
                sessionStorage.setItem('salary_request_detail_timestamp', Date.now().toString());
                setIsLoading(false);
              })
              .catch(err => {
                console.error('Error fetching updated data:', err);
                setError('Failed to refresh data after submission.');
                setIsLoading(false);
              });
          }, 1000); // รอ 1 วินาทีเพื่อให้ข้อมูลในฐานข้อมูล update ก่อน
        } else {
          throw new Error('Request failed with status: ' + (result?.status || 'unknown'));
        }
      })
      .catch((error: any) => {
        // Enhanced error logging and user feedback
        console.error('Error submitting salary request:', error);
        
        // More specific error message
        const errorMsg = error.response?.data?.message || 
                        error.message || 
                        t('adv_salary_request.generic_error') || 
                        'An error occurred while processing your request';
                        
        setTemplateError(errorMsg);
      })
      .finally(() => {
        setButtonDisable(false);
      });
  }

  function inRange(x: number, min: number, max: number) {
    return x >= min && x <= max;
  }

  const handleLogout = () => {
    setShowModal(false);
  };

  const hanleCancelRequest = () => {
    setShowModal(false);
    setbtnConfirm('no');
  };

  const checkOpenRequest = data?.periodAvailable !== null ? true : false;
  
  // Optimize rendering by memoizing the approval status
  const hasApprovedAmount = data?.advanceSalaryRequest?.approvedAmount !== null;

  //console.log('btnConfirm=', btnConfirm);

  return (
    <>      
      <NotifyModal
        btnText={t('btn_ok')}
        type="text"
        btnConfirm={btnConfirm}
        keyboard={modalKeyboard}
        backdrop={modalBackdrop}
        confirm={modalConfirm}
        confirmFunc={() =>
          hanleCancel(data?.advanceSalaryRequest?.id, 'confirm')
        }
        title={modalTitle}
        body={modalBody}
        showModal={showModal}
        handleContinue={handleLogout}
        onHide={() => hanleCancelRequest()}
        onExiting=""
        Style={{ background: '' }}
      />
      {isLoading ? (
        <div className="text-center my-5">
          <span>Loading...</span>
        </div>
      ) : (
        <div className="salary-request box">
          <h6 className="adv-request-title">{t('adv_salary_request.title')}</h6>
          <div className="hr"></div>
          {data?.periodAvailable === true ? (
            <Container fluid className="adv_salary_re">
              <Row>
                <Col>
                  {templateError && (
                    <InputGroup className="mb-0 mt-3">
                      <Alert key="danger" variant="danger" className="message">
                        {templateError}
                      </Alert>
                    </InputGroup>
                  )}
                  <InputGroup className="mb-3 mt-3">
                    <Form.Control
                      pattern="[+-]?\d+(?:[.,]\d+)?"
                      value={value === 0 ? '' : value}
                      onChange={handleChange}
                      placeholder="0"
                      aria-label="salary"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Text id="input_salary_reqeust">
                      {t('adv_salary_request.unit')}
                    </InputGroup.Text>
                  </InputGroup>

                  <InputGroup className="mb-2 mt-3">
                    <Alert key="info" variant="info" className="message">
                      {t('adv_salary_request.massage')}
                    </Alert>
                  </InputGroup>
                  <InputGroup className="mb-3 mt-1">
                    <Button
                      variant="primary"
                      className="btn-send"
                      style={{ fontSize: 12 }}
                      onClick={handleSubmit}
                      disabled={buttonDisable}
                    >
                      <span>
                        <img src="../images/pie-chart.svg" alt="Pie chart icon" />
                      </span>
                      <span>
                        {' '}
                        {buttonDisable
                          ? t('loading')
                          : t('adv_salary_request.btn_send_request')}
                      </span>
                    </Button>
                  </InputGroup>
                </Col>
              </Row>
            </Container>
          ) : data?.periodAvailable === false ? (
            <Container fluid className="adv_salary_re">
              <Row>
                <Col>
                  <div className="massage-off-period px-1 p-4">
                    <Alert
                      key="danger"
                      variant="danger"
                      className="message text-center"
                    >
                      <h3>{t('periodOff')}</h3>
                    </Alert>
                  </div>
                </Col>
              </Row>
            </Container>
          ) : (
            <></>
          )}
        </div>
      )}
      {data && data?.advanceSalaryRequest !== null ? (
        <div className="salary-request-detail box">
          <Container fluid className="adv_salary_request-detail">
            <Row>
              <Col xs={8}>
                <div className="d-flex align-items-center">
                  <h5 className="adv-title-detail mb-0">
                    {t('adv_salary_request.title_detail')}
                  </h5>
                  <Button 
                    variant="link"
                    className="p-0 ml-2"
                    aria-label="Refresh data"
                    title="Refresh"
                    onClick={refreshData}
                    style={{ fontSize: '0.9rem' }}
                  >
                    <i className="fa fa-refresh" aria-hidden="true"></i>
                  </Button>
                </div>
                <InputGroup className="mb-1 mt-2">
                  <div className="mt-0">
                    <img src="/images/calendar.svg" alt="Calendar icon" />
                  </div>
                  <span className="adv-date mt-1 m-1">
                    {moment(data?.advanceSalaryRequest?.requestDate + 'Z')
                      .tz(timezoneStr)
                      .format('DD MMM YYYY')}
                  </span>
                </InputGroup>
              </Col>
              <Col xs={4}>{renderStatus()}</Col>
            </Row>
            <Row>
              <Col xs={2}>
                <InputGroup className="mt-3">
                  <img src="/images/Icon_1.svg" alt="Request icon" />
                </InputGroup>
              </Col>
              <Col xs={7}>
                <InputGroup className="mt-3">
                  <h6 className="title-request">
                    {t('adv_salary_request.requested')}
                  </h6>
                </InputGroup>
                <InputGroup className="mt-0">
                  <h6 className="text-detail">
                    {t('adv_salary_request.requested_detail')}
                  </h6>
                </InputGroup>
              </Col>
              <Col xs={3}>
                <InputGroup className="mt-3">
                  <span className="amount-request">
                    {data?.advanceSalaryRequest?.requestAmountStr || 0}{' '}
                      {t('adv_salary_request.unit')}
                  </span>
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col className="mt-3">
                <div className="hr-bottom"></div>
              </Col>
            </Row>

            {hasApprovedAmount && (
              <>
                <Row>
                  <Col xs={2}>
                    <InputGroup className="mt-3">
                      <img src="/images/Icon_2.svg" alt="Approval icon" />
                    </InputGroup>
                  </Col>
                  <Col xs={7}>
                    <InputGroup className="mt-3">
                      <h6 className="title-request">
                        {t('adv_salary_request.approved')}
                      </h6>
                    </InputGroup>
                    <InputGroup className="mt-0">
                      <h6 className="text-detail">
                        {t('adv_salary_request.approved_detail')}
                      </h6>
                    </InputGroup>
                  </Col>
                  <Col xs={3}>
                    <InputGroup className="mt-3">
                      <span className="amount-approved">
                        {data?.advanceSalaryRequest?.approveAmountStr || 0} {' '}
                      {t('adv_salary_request.unit')}
                      </span>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3">
                    <div className="hr-bottom"></div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup className="mt-3">
                      <h6 className="text-remark">
                        {t('adv_salary_request.remark')}
                      </h6>
                    </InputGroup>
                    <InputGroup className="mt-1 mb-3">
                      <div className="text-remark-detail">
                        {data?.advanceSalaryRequest?.remark ?? 'ไม่มี'}
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
              </>
            )}
            {data?.periodAvailable && (
              <Row>
                <Col className="text-center mb-4 mt-2">
                  <Button
                    disabled={false}
                    variant="primary"
                    className="btn-cancel"
                    onClick={() => hanleCancel(data?.advanceSalaryRequest?.id, 'del')}
                    style={{ fontSize: 12 }}
                  >
                    <span className="btn-cancel-icon">
                      <img src="../images/cancel.svg" alt="Cancel icon" />
                    </span>
                    <span>{t('adv_salary_request.btn_cancel')}</span>
                  </Button>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
